import { connect } from 'react-redux'
import ServiceViewSuggestedLocations from 'src/components/services/view/ServiceViewSuggestedLocations'
import * as actions from '../../state/actions/services'
import { IStoreState } from 'src/types/state'

export function mapStateToProps(state: IStoreState, ownProps: any): any {
  const { serviceId } = ownProps
  return {
    serviceId,
    serviceSuggestedLocationList: state.service.locationList
  }
}

export function mapDispatchToProps(dispatch: any) {
  return {
    getSuggestedLocationList: (serviceId: string): any => {
      return dispatch(actions.getSuggestedLocationList(serviceId))
    }
  }
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(ServiceViewSuggestedLocations)



// WEBPACK FOOTER //
// ./src/containers/services/ServiceViewSuggestedLocations.ts